import { Shift } from '../../../models'
import { TrackType } from '../../types/trackTypes'
import { Track } from './Track'

export const getOrphanedTracks = (tracks: Track[], shifts: Shift[]): Track[] => tracks
    .filter(track => track.shift)
    .filter(track => {
        const trackShift = shifts.find((shift) => shift.id === track.shift?.id)

        if (! trackShift) {
            return false
        }

        return ! trackShift.shiftPlannings.some(shiftPlanning => shiftPlanning.planned && shiftPlanning.user.id === track.owner.id)
    })

export const getApprovedFilterValue = (trackType?: TrackType): number | undefined => {
    if (trackType === TrackType.review) {
        return 0
    }
    if (trackType === TrackType.finished) {
        return 1
    }
    return undefined
}
